import { ExclamationCircleIcon } from "@heroicons/react/24/solid/index.js";
import { ReactNode } from "react";
import { WeekDayEnum } from "../gql/graphql.ts";
import dayjs from "dayjs";

function weekDayEnumToInt(weekDayEnum: WeekDayEnum) {
  switch (weekDayEnum) {
    case WeekDayEnum.Sunday:
      return 0;
    case WeekDayEnum.Monday:
      return 1;
    case WeekDayEnum.Tuesday:
      return 2;
    case WeekDayEnum.Wednesday:
      return 3;
    case WeekDayEnum.Thursday:
      return 4;
    case WeekDayEnum.Friday:
      return 5;
    case WeekDayEnum.Saturday:
      return 6;
  }
}
export function EmptyCalendarMessage({
  message,
  icon,
  availableWeekDays,
  notAvailableMessage,
  day,
}: {
  message: string;
  notAvailableMessage: string;
  availableWeekDays: WeekDayEnum[];
  day?: Date;
  icon?: ReactNode;
}) {
  function weekDayNotAvailable() {
    if (!day) return false;
    return !availableWeekDays.some(
      (availableWeekDay) =>
        dayjs(day).day() === weekDayEnumToInt(availableWeekDay),
    );
  }

  return (
    <div className={"flex flex-col items-center space-y-2"}>
      {icon ?? <ExclamationCircleIcon className={"h-7 w-7"} />}
      <p className={"text-center text-sm"}>
        {weekDayNotAvailable() ? notAvailableMessage : message}
      </p>
    </div>
  );
}
